
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "wallet",
  "title": "Account Wallet",
  "sidebar_label": "Account Wallet"
};
const slug = 'wallet';
const tableOfContents = [{
  "title": "Account Wallet",
  "slug": "account-wallet",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <_Heading level={2} id={"account-wallet"} nextElement={{
      "type": "paragraph"
    }}>Account Wallet</_Heading>
    <p>{`Our platform includes an account wallet feature that allows accounts (sellers, service providers, campaign owners) to track and manage their sales and payouts. This feature is connected to Stripe Connect, which is used to process the payments for sales and payouts.`}</p>
    <p>{`Using the account wallet feature, accounts can:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`View their current balance, which is updated whenever they make a sale or receive a payout.`}</li>
      <li parentName="ul">{`Request a payout to withdraw their balance to their linked bank account. Payouts are processed through Stripe Connect and may take a few days to complete.`}</li>
      <li parentName="ul">{`View a history of their sales and payouts, including the date, amount, and status of each transaction.`}</li>
    </ul>
    <p>{`The account wallet feature is a convenient and transparent way for accounts to track their earnings and manage their payouts. It helps to streamline the payment process and reduce the risk of errors or oversights.`}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
